import { useEffect, useRef } from "react";
import API from "../lib/api";
import { POST_LOGIN_KEY } from "../lib/checkout";
import { useAuth } from "../context/AuthContext";
import { identify, track } from "../lib/analytics";

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        const r = await API.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        // Managed (Google) sign-in: the browser is the only side that learns a sign-up completed.
        identify(r.data);
        if (r.data.is_new) track("signup_completed", { method: "google" });
      } catch (e) {
        // fall through — dashboard will prompt sign-in
      }
      const back = sessionStorage.getItem(POST_LOGIN_KEY);
      sessionStorage.removeItem(POST_LOGIN_KEY);
      window.location.href = back && back.startsWith("/") ? back : "/dashboard";
    })();
  }, [setUser]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-cream text-navy">
      <div className="w-10 h-10 border-2 border-navy/20 border-t-navy rounded-full animate-spin" />
      <p className="mt-4 font-serif text-lg">Signing you in…</p>
    </div>
  );
}
